var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media"},[_c('div',{staticClass:"media-inner media-left",class:_vm.compCssClasses},[_vm._t("left")],2),_c('div',{staticClass:"media-inner media-right",class:_vm.compCssClasses},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }